module.exports = __webpack_public_path__ + "static/media/embed-warning.44f9002f.png";